import Icon from '@/components/ui/AppIcon';

const ConservationBanner = () => {
  return (
    <div className="bg-gradient-to-r from-primary/10 to-secondary/10 rounded-xl p-6 border-l-4 border-primary">
      <div className="flex items-start space-x-4">
        <div className="flex-shrink-0">
          <div className="w-12 h-12 bg-primary rounded-full flex items-center justify-center">
            <Icon name="ShieldCheckIcon" size={24} className="text-primary-foreground" />
          </div>
        </div>
        <div className="flex-1">
          <h3 className="text-lg font-headline font-bold text-foreground mb-2">
            Marine Conservation Commitment
          </h3>
          <p className="text-sm text-muted-foreground leading-relaxed mb-3">
            Cyprus waters are home to protected species and marine reserves. As responsible divers, we must respect marine life, maintain safe distances, and never touch or disturb underwater creatures. Together, we can preserve this underwater paradise for future generations.
          </p>
          <div className="flex flex-wrap gap-2">
            <span className="inline-flex items-center space-x-1 bg-success/10 text-success px-3 py-1 rounded-full text-xs font-medium">
              <Icon name="CheckCircleIcon" size={14} />
              <span>Look but don't touch</span>
            </span>
            <span className="inline-flex items-center space-x-1 bg-success/10 text-success px-3 py-1 rounded-full text-xs font-medium">
              <Icon name="CheckCircleIcon" size={14} />
              <span>Respect marine reserves</span>
            </span>
            <span className="inline-flex items-center space-x-1 bg-success/10 text-success px-3 py-1 rounded-full text-xs font-medium">
              <Icon name="CheckCircleIcon" size={14} />
              <span>Report sightings</span>
            </span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ConservationBanner;